import { Form, Switch } from "antd";
import React from "react";

const Diabetic: React.FC = () => {
  return (
    <Form.Item
      name={["subjectMetric", "isDiabetic"]}
      label="Diabetic"
      valuePropName="checked"
    >
      <Switch defaultValue={false}  />
    </Form.Item>
  );
};

export default Diabetic;
